import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { useAuth0 } from "@auth0/auth0-react";
import QRCodeComponent from '../components/QRCodeComponent';
import { hasRoles } from '../common/auth0Common';

const Profile = () => {
  const { user, getAccessTokenSilently } = useAuth0();
  const { name, picture, email, email_verified, nickname } = user;
  const [activeCompany, setActiveCompany] = useState("");
  const [companyUrl, setCompanyUrl] = useState("");
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  useEffect(() => {
    if (hasRoles(user, ['company'])) {
      getUserId();
    }
  }, []);

  const getUserId = async () => {
    try {
      let activeCompany = {};
      if (localStorage.getItem('selectedCompany')) {
        activeCompany = JSON.parse(localStorage.getItem('selectedCompany'))
      }
      else {
        const token = await getAccessTokenSilently();

        const response = await fetch(
          `${serverUrl}/api/user`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const dbUser = await response.json();
        activeCompany = dbUser?.userCompanies[0]
      }

      setActiveCompany(activeCompany);
      const currentDomain = window.location.origin;
      const companyUrl = `${currentDomain}/products/${encodeURIComponent(activeCompany.companyName)}`;
      setCompanyUrl(companyUrl);

    } catch (error) {
      // swalWithBootstrapButtons.fire({
      //   title: "Oops...",
      //   text: error.message,
      //   icon: "error"
      // });
    }
  };
  const handleClick = (e) => {
    e.preventDefault(); // Verhindert den Standard-Link-Verhalten

    // Cookie "myCookieConsent" löschen
    document.cookie = "myCookieConsent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    // Seite neu laden
    window.location.reload();
  };

  return (
    <div>
      <div className="text-center">
        <img
          //src={picture}
          src="https://img.icons8.com/?size=100&id=tZuAOUGm9AuS&format=png&color=000000"
          alt="Profile"
          className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
        />
      </div>
      {hasRoles(user, ['company']) && activeCompany && companyUrl &&
        <div>
          <QRCodeComponent text={companyUrl} displaySize={128} downloadSize={256} />
        </div>
      }


      <div className="col-md text-center text-md-left">
        <h2>{name}</h2>
        <p className="lead text-muted">{email} | {email_verified ? "verifiziert" : "noch nicht verifiziert"}</p>
        {hasRoles(user, ['company']) && <h6>Unternehmen: {activeCompany ? activeCompany.companyName : "Kein verknüpftes Unternehmen gefunden."}</h6>}
      </div>
      <hr />
      <div className="row">
        <div className="col-md-6 mb-4 text-center">
          <h6 className="mb-3">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="/privacy-policy"
            >
              <FontAwesomeIcon icon={faLink} className="mr-2" />
              Datenschutzerklärung
            </a>
          </h6>
          <p>
            Hier findest Du unsere Datenschutzerklärung. Bei Fragen oder Anliegen erreichst Du uns jederzeit unter info@mydeserve.ch.
          </p>
        </div>

        <div className="col-md-6 mb-4 text-center">
          <h6 className="mb-3">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="/terms-conditions"
            >
              <FontAwesomeIcon icon={faLink} className="mr-2" />
              Allgemeine Geschäftsbedingungen (AGB)
            </a>
          </h6>
          <p>
            Unsere AGBs findest Du hier. Falls du Fragen hast, melde Dich gerne bei uns unter info@mydeserve.ch.
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-4 text-center">
          <h6 className="mb-3">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto:info@mydeserve.ch"
            >
              <FontAwesomeIcon icon={faLink} className="mr-2" />
              Account verwalten oder löschen
            </a>
          </h6>
          <p>
            Möchtest Du deinen Account ändern oder löschen? Schreib uns einfach!
          </p>
        </div>

        <div className="col-md-6 mb-4 text-center">
          <h6 className="mb-3">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="#"
              onClick={handleClick}
            >
              <FontAwesomeIcon icon={faLink} className="mr-2" />
              Cookie-Einstellungen anpassen
            </a>
          </h6>
          <p>
            Hier kannst Du Deine Cookie-Präferenzen jederzeit ändern.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Profile;